import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { voucherNotesShape } from 'constants/propTypes';
import NoteDetail from 'components/shared/NoteDetail';

import { ErrorMessage, StyledVoucherNotesContainer } from './VoucherDetails.styles';

const VoucherNotes = ({ notes = [], hasError = false }) => (
  <>
    {hasError ? (
      <ErrorMessage>
        <FormattedMessage id="vouchers.getNotesError" />
      </ErrorMessage>
    ) : (
      <StyledVoucherNotesContainer>
        {notes.map((note) => (
          <NoteDetail key={note.id} detail={note} />
        ))}
      </StyledVoucherNotesContainer>
    )}
  </>
);

VoucherNotes.propTypes = {
  notes: voucherNotesShape,
  hasError: PropTypes.bool
};

export default VoucherNotes;
